"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInverseSugarOptions = void 0;
exports.defaultInverseSugarOptions = {
    debug: false,
    defaultScope: "Transient",
    onModuleBinded: undefined,
};
const inversifySugarOptions = Object.assign({}, exports.defaultInverseSugarOptions);
exports.default = inversifySugarOptions;
